import { Trigger } from "../../hooks/useTriggers";
import { useWorkflow, useWorkflows } from "../../../flows/hooks/useWorkflows";
import { useTriggerActions, useTriggerEvents } from "../../hooks/useTrigger";
import { useMemo, useState } from "react";
import {
  Button,
  Card,
  Icon,
  OptionList,
  Popover,
  Stack,
  Title
} from "@introist/react-foundation/v2";
import { IconPickerIcon } from "../../../../components/organisms";
import { SetupCard } from "./SetupCard";
import { SelectorIcon } from "../../../employees/fields/EmployeeFieldSelector";
import { EventTriggerSettings } from "../Settings";
import { InfoTooltip } from "../../../../foundation";

export const WorkflowEditor = ({ trigger }: { trigger: Trigger }) => {
  const { workflow } = useWorkflow(trigger.workflowId!, { enabled: !!trigger.workflowId });
  const { workflows } = useWorkflows({});

  const { availableEvents } = useTriggerEvents();

  const { update } = useTriggerActions();

  const [ref, setRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  const options = useMemo(() => {
    return (workflows ?? []).map(w => ({
      key: w.id,
      title: w.title,
      startAdornment: <SelectorIcon icon="workflows" />
    }));
  }, [workflows]);

  const event = useMemo(() => {
    return availableEvents?.find(e => e.event === trigger.triggerEvent?.event);
  }, [trigger, availableEvents]);

  return (
    <div ref={setRef} style={{ width: "100%", height: "100%" }}>
      {!trigger.workflowId && (
        <SetupCard icon="workflows" title="Select workflow" onClick={() => setOpen(true)} />
      )}
      {trigger.workflowId && (
        <Card style={{ width: "100%", height: "100%", padding: "var(--spacing-xLarge)" }}>
          <Stack vertical style={{ height: "100%" }}>
            <Stack style={{ height: "100%" }}>
              <IconPickerIcon fallbackIcon="workflows" />
              <Button variant="blended" onClick={() => setOpen(true)}>
                {workflow?.title}
              </Button>
              <EventTriggerSettings triggerId={trigger.id} />
            </Stack>
            {event?.resources?.map(r => (
              <Card
                style={{
                  padding:
                    "var(--spacing-small) var(--spacing-small) var(--spacing-small) var(--spacing-medium)"
                }}
              >
                <Stack>
                  <Icon name="hardDrive" />
                  <Title variant="bold">{r.title}</Title>
                  <InfoTooltip
                    filled={false}
                    tooltip={`${r.title} is automatically added as a resource to the automation`}
                  />
                </Stack>
              </Card>
            ))}
          </Stack>
        </Card>
      )}

      <Popover referenceElement={ref} onClose={() => setOpen(false)} open={open}>
        <OptionList
          searchable
          options={options}
          onItemClick={async opt => {
            await update(trigger.id, { workflowId: opt.key });
            setOpen(false);
          }}
        />
      </Popover>
    </div>
  );
};
